'use client';

import type {FC} from 'react';

import {ContentBlockContainer} from '@/components/content-blocks/block-container';
import type {ExtractContentBlockType} from '@/components/content-blocks/ContentBlocks';
import {ImageGallery} from '@/components/image-gallery';

type Props = ExtractContentBlockType<'gallery'>;

export const GalleryContainer: FC<Props> = (props: Props) => {
	const {images, contentBlockOptions, heading, description} = props ?? {};

	if (!images || images.length === 0) {
		return null;
	}

	return (
		<>
			<ContentBlockContainer
				options={contentBlockOptions}
				heading={heading}
				description={description}
			>
				<ImageGallery images={images} aspectRatio={props.aspectRatio} />
			</ContentBlockContainer>
		</>
	);
};
